import "core-js/modules/es.array.join.js";
import React from 'react';
import { Tooltip } from '@applyboard/ui-components';
import { InfoOutlineIcon } from '@applyboard/ui-icons';
function IntakeTooltip(_ref) {
  var generalWaitlistExceptions = _ref.generalWaitlistExceptions,
    generalStatus = _ref.generalStatus;
  var generateTooltipText = function generateTooltipText(status) {
    switch (status) {
      case 'waitlist':
        return 'The school has waitlisted this intake but is still accepting applications. There is no guarantee that the application will be processed.';
      case 'open':
      case 'will_open':
      case 'likely_open':
        return generalWaitlistExceptions ? "".concat(generalWaitlistExceptions === null || generalWaitlistExceptions === void 0 ? void 0 : generalWaitlistExceptions.join(' - ')) : '';
      case 'open_conditionally':
      case 'will_open_conditionally':
      case 'closed_conditionally':
        return '';
    }

    // not reachable
    throw new Error('Unknown program intake general status');
  };
  var tooltipText = generateTooltipText(generalStatus);
  return /*#__PURE__*/React.createElement(React.Fragment, null, tooltipText && /*#__PURE__*/React.createElement(Tooltip, {
    interactive: true,
    title: tooltipText
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginLeft: '8px'
    }
  }, /*#__PURE__*/React.createElement(InfoOutlineIcon, {
    "aria-label": "show ".concat(generalStatus, " disclaimer")
  }))));
}
export default IntakeTooltip;